module.exports = __webpack_public_path__ + "fonts/GalanoGrotesque-Regular.303029a.woff";